"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.f113 = void 0;
exports.f113 = {
    "qafar": [
        3,
        5,
        6
    ],
    "qachʼaʼteem": [
        74
    ],
    "qach’a’teem": [
        74,
        75,
        76
    ],
    "qatari": [
        136
    ],
    "qa'yol": [
        170
    ],
    "qa’yol": [
        170
    ],
    "qimant": [
        178
    ],
    "qawasqar": [
        258
    ],
    "qandisel": [
        323
    ],
    "qwannab": [
        323
    ],
    "qa": [
        4208,
        425
    ],
    "qatar": [
        425
    ],
    "qeltu": [
        585
    ],
    "quibala": [
        936
    ],
    "quang tri bru": [
        1100,
        1101,
        1102
    ],
    "quang": [
        1100,
        1101,
        1102,
        3710,
        7555,
        8923,
        8924,
        8925,
        8926
    ],
    "quop": [
        1151
    ],
    "qaqet": [
        1294
    ],
    "quiotepec": [
        1454
    ],
    "quiotepec chinantec": [
        1454
    ],
    "q̉ʷay̓áyiłq̉": [
        1482
    ],
    "quioco": [
        1484
    ],
    "qiang, northern": [
        1544
    ],
    "qiang": [
        1544,
        6445
    ],
    "qirim": [
        1604,
        1605,
        1606
    ],
    "qirim tili": [
        1604,
        1605,
        1606
    ],
    "qirimtatar": [
        1604,
        1605,
        1606
    ],
    "qırım türkçesi": [
        1604,
        1605,
        1606
    ],
    "qırım": [
        1604,
        1605,
        1606
    ],
    "qırımca": [
        1604,
        1605,
        1606
    ],
    "qin": [
        1636,
        1637
    ],
    "qene drehu": [
        1842
    ],
    "qene": [
        1842
    ],
    "quemayá": [
        1851
    ],
    "qiu": [
        2013
    ],
    "qiuzi": [
        2013
    ],
    "quebec sign language": [
        2350
    ],
    "quebec": [
        2350,
        3178,
        3281
    ],
    "quebecars": [
        2350
    ],
    "québec": [
        2350
    ],
    "québécoise": [
        2350
    ],
    "qibdili mitstsi": [
        2590
    ],
    "qibdili": [
        2590
    ],
    "qau": [
        2760,
        2650
    ],
    "qiandong": [
        2989,
        2991,
        2986
    ],
    "qián-dōng fāngyán": [
        2986
    ],
    "qián-dōng": [
        2986
    ],
    "qing miao": [
        3005,
        3006,
        3007,
        3008,
        3009,
        3050
    ],
    "qing": [
        3005,
        3006,
        3007,
        3008,
        3009,
        3050
    ],
    "quiangan": [
        3150
    ],
    "quiturran": [
        3233
    ],
    "quipiu": [
        3333
    ],
    "qaraqalpaq tili": [
        3455,
        3456,
        3457
    ],
    "qaraqalpaq": [
        3455,
        3456,
        3457
    ],
    "q’eqchi’": [
        3568
    ],
    "qꞌeqchiꞌ": [
        3568
    ],
    "quecchi’": [
        3568
    ],
    "quecchí": [
        3568
    ],
    "qashqari": [
        3666
    ],
    "quicapause": [
        3673
    ],
    "q’anjob’al": [
        3697,
        3827
    ],
    "qanjobal": [
        3697
    ],
    "q'anjob'al": [
        3697
    ],
    "quang lam": [
        3710
    ],
    "queresano occidental": [
        3719
    ],
    "queresano": [
        3719
    ],
    "qazaq": [
        3728,
        3730,
        3731,
        3733,
        3734
    ],
    "qazaq tili": [
        3728,
        3730,
        3731,
        3733
    ],
    "qazaqi": [
        3728,
        3730,
        3731,
        3733,
        3734
    ],
    "qazaqşa": [
        3728,
        3730,
        3731,
        3733
    ],
    "quiligua": [
        3765
    ],
    "quchani": [
        3817
    ],
    "qxû": [
        3843
    ],
    "qxü": [
        3843
    ],
    "quepi-quiri-uate": [
        3887
    ],
    "quepiquiriquat": [
        3887
    ],
    "quepiquiriuate": [
        3887
    ],
    "qarachaytil": [
        3929
    ],
    "qumuqlar": [
        4026,
        4027,
        4028
    ],
    "quaiquer": [
        4081
    ],
    "qabiao": [
        4208
    ],
    "qua": [
        4208,
        5197,
        5198,
        5199,
        5200,
        5201
    ],
    "qa biao": [
        4208
    ],
    "qa qiau": [
        4208
    ],
    "qiau": [
        4208
    ],
    "qabiau": [
        4208
    ],
    "qabiaw": [
        4208
    ],
    "qaqiau": [
        4208
    ],
    "qatvenua": [
        4405
    ],
    "qyol": [
        4585
    ],
    "qyol mam": [
        4585
    ],
    "qyool": [
        4585,
        7757
    ],
    "qyool mam": [
        4585
    ],
    "qato’k": [
        4769
    ],
    "qighaan mongghul": [
        4822
    ],
    "qighaan": [
        4822
    ],
    "quan": [
        4824
    ],
    "quichuañol": [
        5130
    ],
    "qʷi·qʷi·diččaq": [
        5238
    ],
    "quoireng": [
        5501
    ],
    "quuquu’aca": [
        5734
    ],
    "querétaro": [
        5989
    ],
    "querétaro otomi": [
        5989
    ],
    "qandahari pashto": [
        6057
    ],
    "qandahari": [
        6057
    ],
    "quetta-kandahari pashto": [
        6057
    ],
    "quetta-kandahari": [
        6057
    ],
    "quaqua dearuwa": [
        6145
    ],
    "quaqua": [
        6145
    ],
    "quezon palawano": [
        6184
    ],
    "quezon": [
        6184
    ],
    "qiungnai": [
        6244
    ],
    "qaq’oral": [
        6250
    ],
    "quetzaltepec": [
        6383
    ],
    "quetzaltepec mixe": [
        6383
    ],
    "quechua": [
        6393,
        6394,
        6395,
        6397,
        6400,
        6403,
        6404,
        6407,
        6409,
        6413,
        6414,
        6415,
        6416,
        6417,
        6418,
        6421,
        6422,
        6423,
        6425,
        6426,
        6427,
        6430,
        6432,
        6434,
        6436,
        6437,
        6438,
        6440,
        6441,
        6442,
        6446,
        6447,
        6448,
        6431,
        6401,
        6424,
        6429
    ],
    "qheswa": [
        6393
    ],
    "qheswasimi": [
        6393
    ],
    "quechua cusco": [
        6393
    ],
    "quechua qosqo-qollaw": [
        6393
    ],
    "qosqo-qollaw": [
        6393
    ],
    "quechua de cusco-collao": [
        6393
    ],
    "quechua, cusco": [
        6393
    ],
    "qusqu qhichwa simi": [
        6393
    ],
    "qusqu": [
        6393
    ],
    "qhichwa": [
        6393
    ],
    "qusqu runasimi": [
        6393
    ],
    "qullaw": [
        6393
    ],
    "quechua boliviano": [
        6394
    ],
    "quechua, south bolivian": [
        6394
    ],
    "quapaw": [
        6396
    ],
    "quechua, huallaga": [
        6397
    ],
    "quechua huallaguino": [
        6397
    ],
    "quechua de huánuco": [
        6397
    ],
    "quechua de llacón": [
        6397
    ],
    "quechua de matihuaca": [
        6397
    ],
    "qach'abel": [
        6398
    ],
    "quiché": [
        6398,
        6405
    ],
    "qach’abel": [
        6398
    ],
    "quichua, calderón highland": [
        6399
    ],
    "quichua": [
        6399,
        6401,
        6410,
        6412,
        6419,
        6420,
        6424,
        6429,
        6439,
        6444
    ],
    "quichua de la sierra cayambe": [
        6399
    ],
    "quechua, lambayeque": [
        6400
    ],
    "quechua inkawasi-kañaris": [
        6400
    ],
    "quechua de lambayeque": [
        6400
    ],
    "quechua of incahuasi-cañaris": [
        6400
    ],
    "quichua, chimborazo highland": [
        6401
    ],
    "quichua serrano central": [
        6401
    ],
    "quichua de chimborazo": [
        6401
    ],
    "quichua de la sierra": [
        6401
    ],
    "quichua de la sierra chimborazo": [
        6401
    ],
    "quileute": [
        6402
    ],
    "quillayute": [
        6402
    ],
    "quechua, chachapoyas": [
        6403
    ],
    "quechua, north bolivian": [
        6404
    ],
    "quinault": [
        6406
    ],
    "quechua, southern pastaza": [
        6407
    ],
    "quechua del pastaza": [
        6407
    ],
    "quinqui": [
        6408
    ],
    "quechua, chaupihuaranga": [
        6409
    ],
    "quichua, santiago del estero": [
        6410
    ],
    "qač’ab’a:l": [
        6411
    ],
    "quichua, tena lowland": [
        6412
    ],
    "quichua de tena": [
        6412
    ],
    "quichua del oriente": [
        6412,
        6424,
        6429
    ],
    "quijo": [
        6412
    ],
    "quixo": [
        6412
    ],
    "quechua, yauyos": [
        6413
    ],
    "quechua, ayacucho": [
        6414
    ],
    "quechua, ambo-pasco": [
        6415
    ],
    "quechua, cajamarca": [
        6416
    ],
    "quechua, eastern apurímac": [
        6417
    ],
    "quechua del este de apurímac": [
        6417
    ],
    "quechua, huamalíes-dos de mayo huánuco": [
        6418
    ],
    "quichua, imbabura highland": [
        6419
    ],
    "quichua de la sierra imbabura": [
        6419
    ],
    "quichua, loja highland": [
        6420
    ],
    "quechua, cajatambo north lima": [
        6421
    ],
    "quechua, margos-yarowilca-lauricocha": [
        6422
    ],
    "quechua margos": [
        6422
    ],
    "quechua de margos": [
        6422
    ],
    "quechua de margos-cauri-chavinillo huanuco": [
        6422
    ],
    "quechua, north junín": [
        6423
    ],
    "quechua del norte de junín": [
        6423
    ],
    "quichua, napo": [
        6424
    ],
    "quichua del napo": [
        6424
    ],
    "quichua, napo lowland": [
        6424
    ],
    "quechua, pacaraos": [
        6425
    ],
    "quechua, san martín": [
        6426
    ],
    "quechua, huaylla wanca": [
        6427
    ],
    "quechua huanca": [
        6427
    ],
    "quechua wanca": [
        6427
    ],
    "quechua wanka": [
        6427
    ],
    "queyu": [
        6428
    ],
    "quichua, northern pastaza": [
        6429
    ],
    "quechua, corongo ancash": [
        6430
    ],
    "quechua de corongo": [
        6430
    ],
    "quechua, huaylas ancash": [
        6432
    ],
    "qichwa": [
        6432
    ],
    "quechua, sihuas ancash": [
        6434
    ],
    "quechua de sihuas": [
        6434
    ],
    "quechua, chiquián": [
        6436
    ],
    "quechua, chincha": [
        6437
    ],
    "quechua, panao": [
        6438
    ],
    "quechua de pachitea": [
        6438
    ],
    "quichua, salasaca highland": [
        6439
    ],
    "quechua, northern conchucos ancash": [
        6440
    ],
    "quechua de ancash": [
        6440
    ],
    "quechua de pomabamba (ancash)": [
        6440
    ],
    "quechua del norte del callejon de conchucos": [
        6440
    ],
    "quechua, southern conchucos": [
        6441
    ],
    "quechua de conchucos": [
        6441
    ],
    "quechua del callejón de huaylas": [
        6441
    ],
    "quechua del sur de conchucos": [
        6441
    ],
    "quechwa": [
        6441
    ],
    "quechua, puno": [
        6442
    ],
    "quechua collao": [
        6442
    ],
    "quechua qollaw": [
        6442
    ],
    "qollaw": [
        6442
    ],
    "qashqa'i": [
        6443
    ],
    "qashqay": [
        6443
    ],
    "qashqa’i": [
        6443
    ],
    "qašqāʾī": [
        6443
    ],
    "quichua, cañar highland": [
        6444
    ],
    "quichua de la provincia de cañar": [
        6444
    ],
    "qiang, southern": [
        6445
    ],
    "quechua, santa ana de tusi pasco": [
        6446
    ],
    "quechua, arequipa-la unión": [
        6447
    ],
    "quechua de arequipa": [
        6447
    ],
    "quechua de la unión": [
        6447
    ],
    "quechua, jauja wanca": [
        6448
    ],
    "quechua shausha huanca": [
        6448
    ],
    "quenya": [
        6449,
        6450,
        6451,
        6452
    ],
    "quiripi": [
        6453
    ],
    "qiuze": [
        6477,
        6478,
        6479,
        6480,
        6481,
        6482
    ],
    "qurbāti": [
        6560
    ],
    "qarawi": [
        6857
    ],
    "quissama": [
        6966
    ],
    "qassem": [
        7087
    ],
    "qassim": [
        7087
    ],
    "qilai": [
        7295
    ],
    "quequexque": [
        7440
    ],
    "quang tin katu": [
        7555
    ],
    "quilyilhrayrom": [
        7592
    ],
    "qom": [
        7639
    ],
    "qom l’aqtac": [
        7639
    ],
    "qom-lik": [
        7639
    ],
    "qoml’ek": [
        7639
    ],
    "quy": [
        7865,
        7866
    ],
    "qwadza": [
        8246
    ],
    "quimuane": [
        8284,
        8285
    ],
    "quippen-bura": [
        8296
    ],
    "qalmaq": [
        8398,
        8399
    ],
    "qhalaxari": [
        8511
    ],
    "qatabanian": [
        8614
    ],
    "quaiá": [
        8690
    ],
    "qila": [
        8853
    ],
    "qila muji": [
        8853
    ],
    "quang dong": [
        8923,
        8924,
        8925,
        8926
    ],
    "quechan": [
        8933
    ],
    "quecl": [
        8933
    ],
    "qotong": [
        9020,
        9021,
        9022,
        9030,
        9040
    ],
    "quiatoni": [
        9125
    ],
    "quiatoni zapotec": [
        9125
    ],
    "quiegolani": [
        9128
    ],
    "quiegolani zapotec": [
        9128
    ],
    "quiavicuzas": [
        9129
    ],
    "quiavicuzas zapotec": [
        9129
    ],
    "qiubei": [
        9146,
        9147
    ],
    "qiubei sha": [
        9146,
        9147
    ],
    "qiubei zhuang": [
        9146,
        9147
    ],
    "quioquitani-quierí": [
        9166
    ],
    "quioquitani-quierí zapotec": [
        9166
    ],
    "quioquitani": [
        9166
    ],
    "quierí": [
        9166
    ]
};
